import React from 'react';
import '../../src/App.css';

import img from "../../src/asset/Erica-DW-onde-cropped.png";

const LINKS = [
  { label: 'Site Web',           url: 'https://erica-dumwae.com' },
  { label: 'Dernier Album',      url: 'https://erica-dumwae.com/music/' },
  { label: 'Concerts & Tournée', url: 'https://erica-dumwae.com/#tour' },
  { label: 'Podcast & Médias',   url: 'https://erica-dumwae.com/#podcast' },
  { label: 'Soutenir',      url: 'https://erica-dumwae.com/soutenir/' },
  { label: 'Contact',            url: 'https://erica-dumwae.com/#contact' },
];

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0a0a0a" />
    </svg>
  );
}

function Home(props) {
  return (
    <div className="page">
      {/* Decorative glow */}
      <div className="glow" aria-hidden="true" />

      <div className="container">
        {/* ── Profile ── */}
        <header className="profile">
          
          <div className="avatar-ring-disabled">
            
            <div className="avatar-inner">
              <img src={img} alt="Erica DumWae"/>
            </div>
          </div>

          <h1 className="name">Erica DumWae</h1>
          <div className="divider" />
          <p className="title">Auteure-Compositrice &amp; Interprète</p>
          <p className="handle">@ericadumwae</p>

          <nav className="socials" aria-label="Réseaux sociaux">
            <a
              href="https://www.facebook.com/ericadumwae/"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>
            <a
              href="https://www.instagram.com/ericadumwae/"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://www.youtube.com/channel/UCL72viW29dz76GWGSBbhGQw/featured"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <YoutubeIcon />
            </a>
          </nav>
        </header>

        {/* ── Tagline ── */}
        <p className="description">
          Entre musique, image et partage,<br/>découvre mon univers artistique en un clic.
          <br/><i>« Tu seras appelé réparateur de brèche, semeur de vie... »</i>
        </p>

        {/* ── Links ── */}
        <nav className="links" aria-label="Liens">
          {LINKS.map((link) => (
            <a
              key={link.url}
              href={link.url}
              className="link-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="link-shine" aria-hidden="true" />
              {link.label}
            </a>
          ))}
        </nav>

        <footer className="footer">© 2026 - Erica DumWae</footer>
      </div>
    </div>
  );
}

export default Home;